<template>
  <div class="individual-wrap" id="activity202210" v-cloak>
    <AppHeader/>
    <div class="indiv-body-ctn">
      <div class="indiv-ctn">
        <div class="model-list">
          <div class="title-box">六大模块助力决策</div>
          <div class="clearfix m-list">
            <span class="m-item">
              两大特色指数观 <span>大势</span>
            </span>
            <span class="m-item">
              新热点轮动日历 <span>风向</span>
            </span>
            <span class="m-item">
              八大信号池看 <span>策略</span>
            </span>
            <span class="m-item">
              三类专属资讯看 <span>内参</span>
            </span>
            <span class="m-item">
              阿尔法因子智能 <span>选股</span>
            </span>
            <span class="m-item">
              全新维度 <span>诊断</span>
            </span>
          </div>
        </div>
        <nav class="individual-nav">
        	<div class="nav-wrap flex">
        		<span v-for="(nav,i) in navs" :class="curNav==i?'cur':''"
        			@click="curNav=i;" :key="i">{{nav}}</span>
        	</div>
        </nav>
        <div v-show="curNav === 0" class="content content1">
        	<div class="title-box">核心功能</div>
        	<div class="mod-list-box">
        		<div class="mod-list">
        			<div class="mod">
        				<h2 class="mod-title">AI资金决策系统</h2>
        				<div class="mod-con">
        					<div class="top-con">
        						<p>AI活跃度<i>·</i>AI研究度<i>·</i>AI市场热力</p>
        						<p>AI多空博弈<i>·</i>AI慧有财 </p>
        					</div>
        					<div class="btm-con">
        						<p>AI活跃度：算法挖掘，挖掘个股大资金操作轨迹。</p>
        						<p>AI研究度：关注大资金对个股的持续研究度。</p>
        						<p>AI市场热力：关注大资金对个股的持续关注度。</p>
        						<p>AI多空博弈：关注个股日内主动买入和卖出的资金差异。</p>
        						<p>AI慧有财：归纳股价历史走势，综合筹码分析及波浪理论进行分析。</p>
        					</div>
        					<span class="tag">五大特色</span>
        				</div>
        			</div>
        			<div class="mod">
        				<h2 class="mod-title">个股特色诊断</h2>
        				<div class="mod-con">
        					<div class="top-con top-con2">
        						<p>技术分析<i>·</i>资金分析<i>·</i>价值挖掘</p>
        					</div>
        					<div class="btm-con">
        						<p>技术分析涵盖指标决策树、形态标签，AI多周期风险机会比及短期撑压价格位。</p>
        						<p>资金分析采用特有的ACE及DDE等特色指标进行综合分析给出资金活跃度评分。</p>
        						<p>价值挖掘基于大量的研报、公告、舆情进行分析，给出个股安全性与成长性的评级。</p>
        					</div>
        					<span class="tag">三大主题</span>
        				</div>
        			</div>
        		</div>
        		<div class="mod-list">
        			<div class="mod">
        				<h2 class="mod-title">优选策略</h2>
        				<div class="mod-con">
        					<div class="top-con">
        						<p>优选500<i>·</i>赢在开盘<i>·</i>盘中黑马</p>
        						<p>等AI算法生成的8大信号池</p>
        					</div>
        					<div class="btm-con">
        						<p>优选500：通过AI算法动态筛选出值得关注的500只个股。</p>
        						<p>赢在开盘：根据集合竞价的数据计算开盘异动的板块及相关个股。</p>
        						<p>盘中黑马：盘中毫秒级运算，挖掘盘中异动个股。</p>
        					</div>
        					<span class="tag">8大信号池</span>
        				</div>
        			</div>
        			<div class="mod">
        				<h2 class="mod-title">优选指数</h2>
        				<div class="mod-con">
        					<div class="top-con top-con2">
        						<p>多空指数<i>·</i>赚钱效应</p>
        					</div>
        					<div class="btm-con">
        						<p>多空指数：根据集合竞价数据及AI模型演算的多空指数专注大势把握及仓位控制。</p>
        						<p>赚钱效应：盘中逐笔计算把握大盘盘中脉络，辅助决策。</p>
        					</div>
        					<span class="tag">特色指数</span>
        				</div>
        			</div>
        		</div>
        		<div class="mod-list">
        			<div class="mod">
        				<h2 class="mod-title">热点轮动日历</h2>
        				<div class="mod-con">
        					<div class="top-con">
        						<p>全新板块热力值系统<i>·</i>热点轮动日历</p>
        						<p>阶段统计助您紧跟风口</p>
        					</div>
        				</div>
        			</div>
        		</div>
        		<div class="mod-list">
        			<div class="mod">
        				<h2 class="mod-title">优选内参</h2>
        				<div class="mod-con">
        					<div class="top-con">
        						<p>一致预期<i>·</i>热点追踪<i>·</i>短期策略</p>
        					</div>
        					<div class="btm-con">
        						<p>专业团队以机构视角从几百份券商研报和机构调研中为高净值用户优选精华内容，辅助投资者紧跟市场风口。</p>
        					</div>
        				</div>
        			</div>
        			<div class="mod">
        				<h2 class="mod-title">大师特权</h2>
        				<div class="mod-con">
        					<div class="top-con">
        						<p>专属直播课<i>·</i>专属道具</p>
        					</div>
        					<div class="btm-con">
        						<p>专属直播课：券商研究员、财经大咖等定期开板精品课程，千金在手不如一技在身。</p>
        						<p>专属道具：钻石等级+直播间弹幕（100条/月）+大师进程特效+直播间喇叭（20条/月）</p>
        					</div>
        				</div>
        			</div>
        		</div>
        		<div class="mod-list">
        			<div class="mod">
        				<h2 class="mod-title">特色选股（Beta）</h2>
        				<div class="mod-con">
        					<div class="top-con">
        						<p>技术选股<i>·</i>资金选股<i>·</i>基本面选股</p>
        					</div>
        					<div class="btm-con">
        						<p>特有的技术因子+资金因子+基本面因子选股，提前试用，加量不加价。</p>
        					</div>
        				</div>
        			</div>
        			<div class="mod">
        				<h2 class="mod-title">ACE决策系统</h2>
        				<div class="mod-con">
        					<div class="top-con top-con3">
        						<p>利用大指数技术从资金和技术分析层面<br>监控大势变化，辅助用户把握交易机会，<br>控制风险</p>
        					</div>
        				</div>
        			</div>
        		</div>
        	</div>
          <div class="title-box">场景示例</div>
          <div class="tle-btm">滑动图片试看案例</div>
          <div class="imgscroll-box img img2">
            <img :src="require('../../assets/images/activity/activity202210/img6.jpg')" alt="">
          </div>
        </div>
        <div v-show="curNav === 1" class="content">
        	<div class="title-box">核心功能</div>
        	<p class="info">优选大师提供了非常高的自由度去进行研究分析，为您的决策提供参考，下面仅列举一些基本的研究流程及简单案例，更多的精彩待您挖掘！</p>
        	<div class="mod mod2-box">
        		<h2 class="mod-title">推荐研究流程</h2>
        		<div class="mod-con">
        			<div class="btm-con btm-con2">
        				<p>
        					<span><img class="step-t" :src="require('../../assets/images/activity/activity202210/step1.png')" alt=""><em>观大势</em></span>
        					<strong>通过竞价指数观开盘大势/赚钱指数看盘中趋势</strong>
        				</p>
        				<p>
        					<span><img class="step-t" :src="require('../../assets/images/activity/activity202210/step2.png')" alt=""><em>初定研究范围</em></span>
        					<strong>根据您的喜好选择适合的信号池<br>
        						· 偏好热点板块的可以通过热点板块及热点轮动日历寻找心仪的板块。<br>
        						· 内置AI精选动态信号池，选择自己喜欢的信号池<br>
        						· 从专属内参中挖掘心仪的价值标的。<br>
        						· 使用阿尔法因子自定义筛选投资标的。</strong>
        				</p>
        				<p>
        					<span><img class="step-t" :src="require('../../assets/images/activity/activity202210/step3.png')" alt=""><em>过滤研究标的</em></span>
        					<strong>使用个股“优选诊断”：进行专业诊断。</strong>
        				</p>
        				<p>
        					<span><img class="step-t" :src="require('../../assets/images/activity/activity202210/step4.png')" alt=""><em>信号择时判断</em></span>
        					<strong>根据AI决策系统进行判断机会与风险时刻。</strong>
        				</p>
        			</div>
        		</div>
        	</div>
        	<div class="mod">
            <h2 class="mod-title">案例研究展示</h2>
            <div class="mod2-list">
              <div class="mod2-item">
                <h3 class="sub-title">
                	<img :src="require('../../assets/images/activity/activity202210/num1.png')" alt="">
                	<p>竞价多空指数占优，日内机会大于风险。 </p>
                </h3>
                <div class="img">
                	<img :src="require('../../assets/images/activity/activity202210/img1.png')" alt="">
                </div>
              </div>
              <div class="mod2-item">
                <h3 class="sub-title">
                	<img :src="require('../../assets/images/activity/activity202210/num2.png')" alt="">
                	<p>选择盘中黑马策略池查看入池股票。 </p>
                </h3>
                <div class="img">
                	<img :src="require('../../assets/images/activity/activity202210/img2.png')" alt="">
                </div>
              </div>
            </div>
            <div class="mod2-list">
              <div class="mod2-item">
                <h3 class="sub-title">
                	<img :src="require('../../assets/images/activity/activity202210/num3.png')" alt="">
                	<p>点击心仪的部分股票，点击在分时中查看个股诊断。 </p>
                </h3>
                <div class="img">
                	<img :src="require('../../assets/images/activity/activity202210/img3.png')" alt="">
                </div>
              </div>
              <div class="mod2-item">
                <h3 class="sub-title">
                	<img :src="require('../../assets/images/activity/activity202210/num4.png')" alt="">
                	<p> 使用AI决策系统进行个股择时判断。 </p>
                </h3>
                <div class="img">
                	<img :src="require('../../assets/images/activity/activity202210/img4.png')" alt="">
                </div>
              </div>
            </div>


        	</div>
        	<p class="info info-btm">以上案例仅作为展示，不做指导建议，更多研究方法敬请探索~</p>
        </div>
        <p class="note">免责声明：购买优选大师财富版年卡可得财富版年卡(策略版用户购买可得策略版季卡)，优选大师财富版半年卡不附赠大智慧财富版。优选大师非荐股类软件，仅作为数据量化及资讯类分析工具，不可作为投资决策依据；数据分析有一定的局限性，该产品仅作为辅助用户研究及分析的工具，模型参数可进行个性化设置，如仅据此操作，风险自行承担。</p>

        <footer class="footer-bar">
        	<div @click="goParkate" class="btn-buy">
            <strong>超值年卡</strong>
            <span class="price-box"><span class="price-num">16800</span></span>
            <span class="fr btn-box">立即购买</span>
          </div>
          <div @click="goParkateHalfYear"
          	class="btn-buy">
            <!-- <p class="tip-p">限时活动截止：10月31日</p> -->
            <strong>半年卡</strong>
            <span class="price-box"><span class="price-num">9800</span>元</span>
            <span class="fr btn-box">立即购买</span>
          </div>
        </footer>
      </div>
    </div>
    <app-footer />
  </div>
</template>

<script>
  import AppHeader from "@/components/common/AppHeader.vue";
  import AppFooter from "@/components/common/AppFooter.vue";
  export default {
  	name: 'activity202210',
    components: {
      AppHeader,
      AppFooter
    },
    data () {
      return {
        navs:['功能介绍','战法案例'],
        curNav:0,

      }
    },
    created () {
      //document.title = '大智慧启航版';
    },
    methods: {
      goParkate () {
        this.$router.push("/order/confirm/197/12");
      },
      goParkateHalfYear () {
        this.$router.push("/order/confirm/197/6");
      }
    },
  }
</script>

<style lang="scss" scoped>
  a{
  	text-decoration: none;
  }
  ul,li{
  	list-style: none;
  }
  $url:'../../assets/images/activity/activity202210/';
  .individual-wrap{
    //background: url('../images/');
    background-color: #1A1727;
    .indiv-body-ctn{
      background: url($url+'banner.png')no-repeat center top/1200px;
          padding-bottom: 140px;
    }
    .indiv-ctn{
      width: 1200px;
      margin: 0 auto;
    }
    .note{
      font-size: 16px;
      color: #FFD0A8;
      padding: 24px 0 0;
    }
    .info-btm{
      text-align: center;
      padding: 24px 0;
    }
    .title-box{
      font-size: 30px;
      color: #FFD0A8;
      text-align: center;
      font-weight: bold;
      line-height: 65px;
      background: url($url+'titlebg.png')no-repeat center ;
      margin-bottom: 26px;
    }
    .tle-btm{
      font-size: 16px;
      color: #FFD0A8;
      text-align: center;
      font-weight: bold;
      padding-bottom: 8px;
      margin-top: -17px;
    }
  	.model-list{
      padding-top: 377px;
  	  .m-list{
        padding: 0 200px;
        box-sizing: border-box;
        text-align: center;
  	    .m-item{
          width: 256px;
          height: 70px;
          float: left;
          line-height: 64px;
          display: inline-block;
          background-image: linear-gradient(-45deg, #311F35 0%, #6C527D 100%);
          border: 0.5px solid rgba(130,106,85,1);
          box-shadow: inset 0px 2px 5px 0px rgba(255,255,255,0.24);
          border-radius: 8px;
          font-size: 20px;
          margin-bottom: 16px;
          box-sizing: border-box;
          color: #FFD0A8;
          margin-right: 16px;
          &:nth-child(3n+3){margin-right: 0;}
  	      span{
            font-size: 30px;
            color: #FFD0A8;
            text-align: right;
            font-weight: bold;
            padding-left: 10px;
          }
          &:nth-child(2n+2){
            background-image: linear-gradient(270deg, #415C9B 0%, #192542 100%);
          }
  	    }
  	  }
  	}
    .individual-nav{
  		.nav-wrap{
        background: #221F2D;
        border: 0.7px solid rgba(130,106,85,1);
        border-radius: 32.2px;
        width: 469px;
        height: 56px;
        padding: 2px;
        box-sizing: border-box;
        display: flex;
        margin: 19px auto 0;
        cursor: pointer;
  			span{
          font-size: 20px;
          color: #FFD0A8;
          text-align: center;
          display: inline-block;
          width: 227px;
          height: 50px;
          line-height: 50px;
          &:last-child{
            margin-left: 9px;
          }
          &.cur{
            background-image: linear-gradient(179deg, #FFD6A9 0%, #FFBA7F 100%);
            border-radius: 27.3px;
            font-size: 20px;
            color: #222222;
            text-align: center;
            font-weight: bold;
          }
        }
  		}
  	}

  	.content{
      width: 800px;
      margin: 0 auto;
  		.title-box{
        margin-top: 35px;
  			img{}
  		}
      .info{
        font-size: 16px;
        color: #FFD0A8;
        margin-bottom: 34px;
      }
      .mod2-list{
        display: flex;
      }
      .mod{
        .mod2-item{
          display: inline-block;
          width: 398px;
          &:nth-child(2n+1){
            margin-right: 4px;
          }
          img{
            display: block;
            margin: 0 auto;
          }
        }
        .sub-title{
          display: flex;
          align-items: center;
          font-size: 18px;
          color: #FFD0A8;
          font-weight: bold;
          padding: 16px 0 24px;
          width: 384px;
          margin: 0 auto;
          img{width: 20px;height: 20px;display: inline-block;margin: initial;}
          p{display: inline;padding-left: 8px;}
        }
        .mod-title{
          width: 221px;
          height: 44px;
          background: url($url+'title.png')no-repeat center/100%;
          font-size: 20px;
          line-height: 44px;
          color: #663B16;
          font-weight: bold;
           padding-left: 20px;
        }
        .btm-con{
          background: url($url+'bg4.png') #2A2734 no-repeat;
          background-size: 100% auto;
        }
        .btm-con2{
         // background: rgba(42,39,52,0.30);
          border: 0.5px solid rgba(201,181,161,1);
          box-shadow: 0px 4px 20px 0px rgba(0,0,0,0.1);
          border-radius: 10px;
          width: 618px;
          height: 404px;
          margin-top: 12px;
          margin-bottom: 72px;
          padding: 24px;
          box-sizing: border-box;
          p{
            padding-bottom: 16px;
            &>span{
              display: block;
              padding-bottom: 2px;
              &>em{
                display: inline-block;
                font-size: 16px;
                color: #FFEDDD;
                font-weight: bold;
                padding: 0 6px;
                background: #8E44B8;
                border-radius: 4px;
                line-height: 26px;
                margin-left: 6px;
              }
            }
            strong{
              line-height: 25px;
              font-weight: normal;
            }
          }
          .step-t{
            height: 24px;
          }
        }
        &.mod2-box{
          width: 618px;
          margin: 0 auto;
          p{
            font-size: 18px;
            color: #FFD0A8;
          }
        }
      }
  		.mod-list-box{
        margin-bottom: -30px;
  			.mod-list{

          display: flex;
          justify-content: center;
  				.mod{
            padding-top: 68px;
            position: relative;
            box-sizing: border-box;
            margin-bottom: 58px;
            &:nth-child(2n+1){margin-right: 60px;}
  					.mod-title{
              width: 221px;
              height: 44px;
              background: url($url+'title.png')no-repeat center/100%;
              font-size: 20px;
              color: #663B16;
              font-weight: bold;
              padding-left: 20px;
              line-height: 44px;
              margin-bottom: 24px;

              position: absolute;
              top: 0;
              left: 0;
            }
  					.mod-con{
              position: relative;
              width: 470px;
              border: 0.5px solid rgba(201,181,161,1);
              box-shadow: 0px 4px 20px 0px rgba(0,0,0,0.1);
              border-radius: 10px;
              height: 100%;
              background: rgba(42,39,52,0.30);
              box-sizing: border-box;
              padding-top: 103px;
  						.top-con{
                background-image: linear-gradient(135deg, #474259 0%, #221F2D 100%);
                // border: 0.5px solid rgba(201,181,161,1);
                 border-radius: 10px 10px 0px 0px;
                font-size: 22px;
                color: #FFEDDD;
                font-weight: bold;
                text-align: center;
                height: 103px;
                display: flex;
                align-items: center;
                flex-direction: column;
                justify-content: center;
                border-bottom: 0;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                i{padding: 0 12px;}
  							p{
                  padding-bottom: 8px;
                  flex: none;
                }
  						}
  						.btm-con{
                // background: url($url+'bg4.png') #2A2734 no-repeat;
                // background-size: 100% auto;
                border-top: 0.5px solid rgba(201,181,161,1);
                font-size: 18px;
                color: #FFD0A8;
                padding: 24px;
                height: 100%;
                box-sizing: border-box;
                border-radius: 0 0 10px 10px;
  							p{
                  padding-bottom: 12px;
                }
  						}

  						.tag{
                font-size: 16px;
                color: #663B16;
                line-height: 28px;
                background: #FFD0A8;
                border-radius: 10.5px;
                display: block;
                position: absolute;
                right: 0;
                padding: 0 6px;
                top: -14px;
              }
  					}
  				}
          &:nth-child(3){
            .mod{
              width: 1000px;
              margin: 0 0 58px;
              .mod-con{
                width: 100%;
                .top-con{
                  border-radius: 10px;
                }
              }
            }
          }
          &:nth-child(5){
            .mod{
              &:nth-child(2){
                .top-con{
                  height: 100%;
                  border-radius: 10px;
                  padding: 0 28px;
                  box-sizing: border-box;
                  text-align: left;
                }
              }
            }
          }
  			}
  		}
      .imgscroll-box{
        width: 335px;
        height: 610px;
        border:10px solid  #473C41;
        border-radius: 20px;
        box-sizing: border-box;
        overflow-y: scroll;
        margin: 0 auto;
        img{width: 100%;border-radius: 10px;}
        &::-webkit-scrollbar {
          width:6px;
        }
        &::-webkit-scrollbar-track {
          -webkit-box-shadow: inset006pxrgba(255, 255, 255, 0.3);
          border-radius: 10px;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background: rgba(255, 255, 255, 0.1);
          -webkit-box-shadow: inset006pxrgba(255, 255, 255, 0.5);
        }
        &::-webkit-scrollbar-thumb:window-inactive {
          background: rgba(255, 255, 255, 0.2);
        }
      }
  	}
    .content1{
      width: 100%;
    }
    .footer-bar{
      text-align: center;
      position: fixed;
      bottom: 20px;
      left: 0;
      z-index: 10;
      width: 100%;
      .btn-buy{
        width: 384px;
        height: 54px;
        background-image: linear-gradient(270deg, #FFB271 0%, #FFDCB6 100%);
        border: 1px solid rgba(255,255,255,1);
        border-radius: 27px;
        font-weight: bold;
        display: inline-block;
        padding-left: 43px;
        padding-right: 148px;
        position: relative;
        display: inline-flex;
        line-height: 52px;
        box-sizing: border-box;
        color: #663B16;

        strong{
          font-size: 18px;
        }
        .price-box{
          font-size: 16px;
          .price-num{
            font-size: 26px;
            padding-left: 16px;
          }
        }
        .btn-box{
          width: 148px;
          background-image: linear-gradient(270deg, #FFB271 0%, #FFDCB6 100%);
          border: 1px solid rgba(255,255,255,1);
          border-radius: 27px;
          font-size: 18px;
          font-weight: normal;
          height: 100%;text-align: center;
          position: absolute;
          right: -1px;color: #663B16;
          top: -1px;
          &:before{
            width: 100%;
            height: 100%;
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            background-color: rgba(255,255,255,0.1);
            opacity: 0;border-radius: 27px;
          }
          &:hover{
            &:before{opacity: 1;}
          }
        }
        .tip-p{
          position: absolute;
          top: -43px;
          left: 0;
          width: 100%;
          text-align: center;
          font-weight: normal;
        }
        &:last-child{
          background-image: linear-gradient(270deg, #03001E 0%, #7303C0 51%, #FF9BC8 100%);
          border: 1px solid rgba(255,255,255,1);
          border-radius: 27px;
          color: #FFEDDD;
          margin-left: 32px;
          .price-box{
            .price-num{

            }
          }
          .btn-box{
            background-image: linear-gradient(270deg, #03001E 0%, #7303C0 51%, #FF9BC8 100%);
            border: 1px solid rgba(255,255,255,1);
            border-radius: 27px;
            color: #FFEDDD;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/activity/activity202210.vue